<template>
  <!-- dividends -->
  <div class="w3-container w3-small" id="dividends">
    <div class="w3-hide-large" style="margin-top:80px"></div>
    <h1 class="w3-xxlarge w3-text-black">
      <b>Dividends.</b>
    </h1>
    <hr style="width:50px;border:5px solid black" class="w3-round" />
    <div></div>
    <div class="w3-clear">
      <div class="w3-responsive">
        <table class="w3-table-all">
          <caption @if="dividends" style="text-align:left; font-size:medium">
            Proposed Dividends
            {{
              dividends.length > 0 ? " For Fiscal Year " + dividends[0].fy : ""
            }}
          </caption>
          <thead class="w3-gray">
            <th class="nowrap">Stock Symbol</th>
            <th class="wrap">Company Name</th>
            <th class="w3-align-right nowrap">Cash Dividend(%)</th>
            <th class="w3-align-right nowrap">Stock Dividend(%)</th>
            <th class="nowrap">Book Close Date</th>
            <th class="nowrap">Action</th>
          </thead>
          <tbody>
            <tr v-show="dividendsloading">
              <td colspan="6">Loading...</td>
            </tr>
            <tr v-show="dividendsmessage">
              <td colspan="6">{{ dividendsmessage }}</td>
            </tr>
            <tr
              v-show="!dividendsloading"
              v-for="dividend in dividends"
              v-bind:key="dividend.stockSymbol + dividend.agmDate"
            >
              <td class="nowrap">
                <span :title="dividend.companyName">{{
                  dividend.stockSymbol
                }}</span>
              </td>
              <td class="nowrap">{{ dividend.companyName }}</td>
              <td class="w3-right-align nowrap">{{ dividend.cashDividend }}</td>
              <td class="w3-right-align nowrap">
                {{ dividend.stockDividend }}
              </td>
              <td class="nowrap">{{ dividend.bookCloseDate }}</td>
              <td class="w3-right-align nowrap">
                <button
                  :disabled="!dividend.cashDividend"
                  @click="exportText(dividend, 'cash')"
                >
                  <i class="fa fa-download"></i>&nbsp;
                  <i class="fa fa-money"></i>
                </button>
                <button
                  :disabled="!dividend.stockDividend"
                  @click="exportText(dividend, 'stock')"
                >
                  <i class="fa fa-download"></i>&nbsp;
                  <i class="fa fa-file"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import DataService from "@/services/DataService";
import { saveAs } from "file-saver";
import moment from "moment";

export default {
  name: "Dividend",
  components: {},
  data() {
    return {
      dividends: [],
      selectedFy: "",
      dividendsloading: false,
      dividendsmessage: "",
    };
  },
  methods: {
    async getdividends() {
      this.dividendsloading = true;
      this.dividendsmessage = "";
      const response = await DataService.getDividendsFromApi(this.selectedFy);
      if (response.data) {
        this.dividends = response.data;
        if (this.dividends.length > 0) {
          this.selectedFy = this.dividends[0].fy;
          this.dividendsmessage = "";
        } else {
          this.dividendsmessage = "No Data Found";
        }
      }
      this.dividendsloading = false;
    },
    formatDate(date) {
      return moment(String(date), "YYYY-MM-DD").format("YYYYMMDD");
    },
    exportText(dividend, type) {
      var date = this.formatDate(new Date().toISOString().slice(0, 10));
      var txt = "";
      var filename = "";
      if (type == "cash") {
        filename = `NDIV${date}-${dividend.stockSymbol}.txt`;
        txt = `Subject                          :Ndividends 
Date                             :${date}
Segname                          :NDIVMMDD.TXT
Stock code                       :${dividend.stockSymbol}
Security Short Name              :${dividend.companyName}    
Financial Year                   :${dividend.fyStartDate} to ${
          dividend.fyEndDate
        }
Dividend Type (Interim / Final)  :Final
Ex date                          :${this.formatDate(dividend.bookCloseDate)}
Book Closure Period              :${this.formatDate(
          dividend.bookCloseDate
        )} to ${this.formatDate(dividend.agmDate)}
Record date                      :${this.formatDate(
          moment(dividend.bookCloseDate, "YYYY-MM-DD")
            .add(-1, "days")
            .toISOString()
        )}
Cash Dividend                    :${dividend.cashDividend}% Which means Rs. ${
          dividend.cashDividend
        } for every share.
Payment Date for cash dividend   :One week after AGM completion date
      `;
      } else if (type == "stock") {
        filename = `NSTOCKDIV${date}-${dividend.stockSymbol}.txt`;
        txt = `Subject                          :NStockdividends 
Date                             :${date}
Segname                          :NStockIVMMDD.TXT
Stock code                       :${dividend.stockSymbol}
Security Short Name              :${dividend.companyName}    
Ex date                          :${this.formatDate(dividend.bookCloseDate)}
Book Closure Period              :${this.formatDate(
          dividend.bookCloseDate
        )} to ${this.formatDate(dividend.agmDate)}
Record date                      :${this.formatDate(
          moment(dividend.bookCloseDate, "YYYY-MM-DD")
            .add(-1, "days")
            .toISOString()
        )}
Stock Dividend                   :${dividend.stockDividend}% or ${
          dividend.stockDividend
        } extra share for every 100 share
Payment Date for cash dividend   :One month after AGM completion date the shareholder receive physical certificate.
      `;
      }
      var blob = new Blob([txt], {
        type: "text/plain;charset=utf-8",
      });
      saveAs(blob, filename);
    },
  },
  created() {
    this.getdividends();
  },
};
</script>

<style></style>
